/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  accountProtectionRequest,
  accountProtectionSuccess,
  accountProtectionFailed,
  enrollAccountProtectionServiceSuccess,
  enrollAccountProtectionServiceRequest,
  enrollAccountProtectionServiceFailed,
} from '../reducer/accountProtectionSlice';
import {
  fetchAccountProtectionInsuranceDetails,
  SubmitEnrollAccountProtectionService,
} from '../api';

export function* fetchAccountProtectionDetails(action) {
  try {
    const { accountId, customerId } = action.payload;
    const response = yield call(
      fetchAccountProtectionInsuranceDetails,
      'getAccountProtectionInsuranceDetail',
      accountId,
      customerId
    );
    console.log('response_saga', response);
    const status = Number(response?.status);
    if ([400,401, 402, 404, 500].includes(status)) {
      yield put(accountProtectionFailed(response));
    } else {
      yield put(accountProtectionSuccess(response));
    }
  } catch (error: any) {
    yield put(accountProtectionFailed(error || 'Something went wrong'));
  }
}

export function* SubmitAccountProtectionServiceRequest(action) {
  try {
    console.log('SubmitAccountProtectionServiceRequest', action);
    const { accountId, customerId, recaptchaToken, payload } = action.payload;
    const response = yield call(
      SubmitEnrollAccountProtectionService,
      'enrollAccountProtectionService',
      accountId,
      customerId,
      {
        ...payload,
        recaptchaToken,
      }
    );
    console.log('SubmitAccountProtectionServiceresponse', response);
    const status = Number(response?.status);
    if ([400, 401, 402, 404, 500].includes(status)) {
      yield put(enrollAccountProtectionServiceFailed(response));
    } else {
      yield put(enrollAccountProtectionServiceSuccess(response?.data));
    }
  } catch (error) {
    yield put(enrollAccountProtectionServiceFailed(error));

    console.log('Error Response', e);
  }
}

export function* watchAccountProtectionDetails() {
  yield takeLatest(
    accountProtectionRequest.type,
    fetchAccountProtectionDetails
  );
  yield takeLatest(
    enrollAccountProtectionServiceRequest.type,
    SubmitAccountProtectionServiceRequest
  );
}
